import styled from "styled-components"

import Button from "./Button"
import SpecialText from "./SpecialText"
import ButtonContainer from "./ButtonContainer"

const InformationCardContainer = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
InformationCardContainer.Button = Button
InformationCardContainer.SpecialText = SpecialText
InformationCardContainer.ButtonContainer = ButtonContainer

export default InformationCardContainer
